<template>
  <li class="fr-item">
    <div class="fr-row">
      <div class="fr-avatar">
        <i class="fal fa-user"></i>
      </div>
      <div class="fr-info">
        <div class="fr-name">{{ user.name }}</div>
        <div class="fr-job" v-if="user.job_title">{{ user.job_title }}</div>
        <div class="fr-badges">
          <span v-if="racis.is_responsible === 1" class="fr-badge fr-badge-r">
            {{ $t('post.page.racis.is_responsible') }}
          </span>
          <span v-if="racis.is_accountable === 1" class="fr-badge fr-badge-a">
            {{ $t('post.page.racis.is_accountable') }}
          </span>
          <span v-if="racis.is_consulted === 1" class="fr-badge fr-badge-c">
            {{ $t('post.page.racis.is_consulted') }}
          </span>
          <span v-if="racis.is_informed === 1" class="fr-badge fr-badge-i">
            {{ $t('post.page.racis.is_informed') }}
          </span>
        </div>
      </div>
      <a :href="'mailto:' + user.email" class="fr-mail" v-if="user.email">
        <i class="fal fa-envelope"></i>
      </a>
    </div>
  </li>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
  name: 'FormRacis',
  props: ['postracis', 'formracis'],
  computed: {
    user() {
      if (this.postracis) {
        return this.postracis.user
      } else if (this.formracis) {
        return this.formracis
      }
      return null
    },
    racis() {
      if (this.postracis) {
        return this.postracis
      } else if (this.formracis) {
        return this.formracis
      }
      return null
    }
  }
}
</script>

<style scoped>
.fr-item {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
}

.fr-item:last-child {
    border-bottom: none;
}

.fr-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.fr-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #eff6ff;
    color: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    flex-shrink: 0;
}

.fr-info {
    flex: 1;
    min-width: 0;
}

.fr-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fr-job {
    font-size: 0.72rem;
    color: #94a3b8;
    margin-top: 1px;
}

.fr-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 6px;
}

.fr-badge {
    font-size: 0.65rem;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 12px;
}

.fr-badge-r {
    background: #dbeafe;
    color: #1d4ed8;
}

.fr-badge-a {
    background: #fef3c7;
    color: #b45309;
}

.fr-badge-c {
    background: #ecfdf5;
    color: #047857;
}

.fr-badge-i {
    background: #f1f5f9;
    color: #475569;
}

.fr-mail {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    flex-shrink: 0;
    transition: all 0.2s;
    text-decoration: none !important;
}

.fr-mail:hover {
    background: #eff6ff;
    color: #3b82f6;
    border-color: #bfdbfe;
}
</style>
